import React from 'react';
export const ViewerContainerSizeContext = React.createContext(undefined);
ViewerContainerSizeContext.displayName = 'ViewerContainerSizeContext';
